import { LayoutSingleColumn, Page } from '../../components';
import { compose } from 'redux';
import { connect } from 'react-redux';
import css from './LandingPage.module.css';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { Suspense } from 'react';
import TrustedExperts from './components/TrustedExperts/TrustedExperts';
import SafetyPriority from './components/SafetyPriority/SafetyPriority';
import HowItWorks from './components/HowItWorks/HowItWorks';
import loadable from '@loadable/component';
import style from '../PageBuilder/SectionBuilder/SectionBuilder.module.css';
import HeroSection from './components/HeroSection/HeroSection';
import EnergyFeature from './components/EnergyFeature/EnergyFeature';

import { propTypes } from '../../util/types';

import { bool, object } from 'prop-types';
import SectionHero from '../PageBuilder/SectionBuilder/SectionHero';
import classNames from 'classnames';

const HealthGuides = loadable(
  () => import('./components/HealthGuides/HealthGuides'),
  {
    ssr: false,
  }
);
const PopularServices = loadable(
  () => import('./components/PopularServices/PopularServices'),
  {
    ssr: false,
  }
);
const ServiceCategories = loadable(
  () => import('./components/ServiceCategories/ServiceCategories'),
  {
    ssr: false,
  }
);
const BrowsePros = loadable(
  () => import('./components/BrowsePros/BrowsePros'),
  {
    ssr: false,
  }
);
const BrowseLocations = loadable(
  () => import('./components/BrowseLocations/BrowseLocations'),
  {
    ssr: false,
  }
);

const DEFAULT_CLASSES = {
  sectionDetails: style.sectionDetails,
  title: style.title,
  description: style.description,
  ctaButton: style.ctaButton,
  blockContainer: style.blockContainer,
};

function LandingPageComponent(props) {
  const { pageAssetsData, inProgress, error } = props;

  const { sections = [], meta = {} } = pageAssetsData || {};

  const heroSections =
    sections?.filter(r => r?.sectionType === 'hero') || [];
  const sectionIds = [];
  const getUniqueSectionId = (sectionId, index) => {
    const candidate = sectionId || `section-${index + 1}`;
    if (sectionIds.includes(candidate)) {
      let sequentialCandidate = `${candidate}1`;
      for (let i = 2; sectionIds.includes(sequentialCandidate); i++) {
        sequentialCandidate = `${candidate}${i}`;
      }
      return getUniqueSectionId(sequentialCandidate, index);
    } else {
      sectionIds.push(candidate);
      return candidate;
    }
  };

  return (
    <Page title={'LandingPage'} scrollingDisabled={false}>
      <LayoutSingleColumn
        topbar={
          <TopbarContainer
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
        }
        sideNav={null}
        useAccountSettingsNav
        currentPage="LandingPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <main className={css.homePage}>
            <Suspense fallback={<div>Loading...</div>}>
              {heroSections.length ? (
                heroSections.map((section, index) => {
                  const isDarkTheme =
                    section?.appearance?.fieldType === 'customAppearance' &&
                    section?.appearance?.textColor === 'white';
                  const classes = classNames({ [style.darkTheme]: isDarkTheme });
                  const sectionId = getUniqueSectionId(section.sectionId, index);
                  return (
                    <>
                   
                    <SectionHero
                      key={`${sectionId}_i${index}`}
                      className={classes}
                      defaultClasses={DEFAULT_CLASSES}
                      isInsideContainer={null}
                      options={{}}
                      {...section}
                      sectionId={sectionId}
                    />
                    </>
                    
                    
                  );
                })
              ) : (
                <HeroSection />
              )}
              
              <ServiceCategories />
              <PopularServices />
              <EnergyFeature />
              <BrowsePros />
              <TrustedExperts />
              <BrowseLocations />
              <HowItWorks />
              <SafetyPriority />
              <HealthGuides />
            </Suspense>
          </main>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
}

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  console.log(state.hostedAssets, '::::::::::::::')
  return { pageAssetsData: pageAssetsData?.landingPage?.data, inProgress, error };
};

const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
